import { FunctionFactory } from "survey-core";

import {
  allMonths,
  medicareExpiryYears,
  irnNumbers,
  medicareExpiryFull
} from "./medicareOptions";
import {
  isValidMedicareNumber,
  isValidMedicareNumberWithIrn
} from "./validateMedicare";
import { checkNhiValues } from "./validateNHI";

export const setupValidators: () => void = () => {
  FunctionFactory.Instance.register("checkNhiValues", checkNhiValues);
  FunctionFactory.Instance.register(
    "isValidMedicareNumber",
    isValidMedicareNumber
  );
  FunctionFactory.Instance.register(
    "isValidMedicareNumberWithIrn",
    isValidMedicareNumberWithIrn
  );
};

export const setupCustomListFunctions: () => void = () => {
  FunctionFactory.Instance.register("medicareExpiryYears", medicareExpiryYears);
  FunctionFactory.Instance.register("allMonths", allMonths);
  FunctionFactory.Instance.register("irnNumbers", irnNumbers);
  FunctionFactory.Instance.register("medicareExpiryFull", medicareExpiryFull);
};
